var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-tag",class:[
  {'s_tag': _vm.STag},
  {'smallCard_tag': _vm.smallCard},
  {'glod_tag': _vm.goldTag}
]},[_vm._v("\n  "+_vm._s(_vm.txt)+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6092093c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TTag.vue
// module id = null
// module chunks = 